import { render, staticRenderFns } from "./btn-arrow-quarternary.vue?vue&type=template&id=b2bd1b8c&scoped=true"
import script from "./btn-arrow-quarternary.vue?vue&type=script&lang=js"
export * from "./btn-arrow-quarternary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bd1b8c",
  null
  
)

export default component.exports